import script from "./UiBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiBtn.vue?vue&type=script&setup=true&lang=ts"

import "./UiBtn.vue?vue&type=style&index=0&id=f17ad628&lang=css"

const __exports__ = script;

export default __exports__